var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat__body",attrs:{"id":"chat__body"}},_vm._l((_vm.msgs),function(item,index){return _c('chat-message',{key:index,attrs:{"userId":_vm.userId,"msg":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }